import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';

export interface RootState {
  auth: {
    isAuthenticated: boolean;
    user: any | null;
    token: string | null;
    loading: boolean;
    error: string | null;
  };
}

export const store = configureStore({
  reducer: {
    auth: authReducer,
  },
});

export type AppDispatch = typeof store.dispatch;